import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'

interface AccountBadgeProps {
	accountName: string
}

/**
 * Small pill badge that identifies which account an entity belongs to.
 * Shown when the entity's account differs from the user's current working account,
 * which happens when the fetch-all-data hierarchy mode is enabled.
 */
export const AccountBadge: React.FC<AccountBadgeProps> = ({ accountName }) => {
	const { t } = useTranslation('common')

	return (
		<div
			className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-primary/5 border border-primary/20 max-w-[160px]"
			title={`${t('navigation.account')}: ${accountName}`}
		>
			<div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />
			<span className="text-xs font-medium text-foreground truncate">
				{accountName}
			</span>
		</div>
	)
}
